import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4eff1d363bb9/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4eff1d363bb9/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de4eff1d363bb9/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4eff1d363bb9/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4eff1d363bb9/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/app/[locale]/industries/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/node_modules/next/dist/client/link.js");
